import { FrameRepository } from '@aipb/gulliver/frame/data-access';
import { NibbleCut } from '@aipb/gulliver/personal-content/model';
import { NibbleActionService } from '@aipb/gulliver/personal-content/util-nibble-action';
import { UseCase } from '@aipb/shared/util/usecase';
import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CopyUrlUseCase implements UseCase<NibbleCut> {
  private nibbleActionService = inject(NibbleActionService);
  private frameRepository = inject(FrameRepository);

  execute(data: NibbleCut): void {
    this.nibbleActionService.copyUrl({
      nibbleCut: data,
      application: this.frameRepository.activeApp
    });
  }
}
